// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pH7n","colMin":"styles_colMin__1k1mS"};